import React from 'react';
import PropTypes from 'prop-types';
import {OptionsHeader} from '../OptionsHeader';
import {
  ErrorCountBlock,
  HexagonCard,
  FullWidthCard,
} from '@learningblocks/storybook-components';
import {OptionsListing, Option} from '../OptionsListing';
import {SlideOneOption} from '../SlideOneOption';
import {SlideThreeOption} from '../SlideThreeOption';
import {OptionsDescription} from './OptionsDescription';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';

export function OptionsBlock(props) {
  const getOptionType = () => {
    let type = '';
    if (props.optionsList.length) {
      type = props.optionsList[0].type;
    }
    return type;
  };
  const setAsNextStep = (optionId) => {
    props.setAsNextStep({optionId, type: props.type});
  };

  let optionType = getOptionType();

  const composeOption = (optionNode) =>
    React.createElement(Option, {
      optionId: NaN,
      type: '',
      setAsNextStep: setAsNextStep,
      optionNode: React.createElement(optionNode, {}),
    });

  const setSlideOneOption = () => composeOption(SlideOneOption);

  const setSlideThreeOption = () => composeOption(SlideThreeOption);

  const setFullWidthCardOption = () => composeOption(FullWidthCard);

  const setHexagonCardOption = () => composeOption(HexagonCard);

  const setOption = () => {
    switch (optionType) {
      case COMPONENT_TYPE.SLIDE_ONE_OPTION:
        return setSlideOneOption();
      case COMPONENT_TYPE.SLIDE_THREE_OPTION:
        return setSlideThreeOption();
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return setFullWidthCardOption();
      case COMPONENT_TYPE.LINK_HEXAGON_MODAL:
        return setHexagonCardOption();
      default:
        return <></>;
    }
  };

  return (
    <div className='designOptions'>
      <OptionsHeader optionsTitle={props.optionsTitle}>
        <ErrorCountBlock
          incorrects={props.incorrects}
          maxIncorrects={props.maxIncorrects}
        />
      </OptionsHeader>
      <div className='designOptions--body'>
        <OptionsDescription message={props.optionsDescription} />
        <OptionsListing
          option={setOption()}
          optionsList={props.optionsList}
          optionType={optionType}
        />
      </div>
    </div>
  );
}

OptionsBlock.propTypes = {
  /**
   * Maximum possible incorrects for the slide
   */
  maxIncorrects: PropTypes.number,
  /**
   * Number of incorrects committed so far
   */
  incorrects: PropTypes.number,
  /**
   * Title to be displayed on the Option Header
   */
  optionsTitle: PropTypes.string,
  /**
   * List of options avaliable for the operation
   */
  optionsList: PropTypes.arrayOf(
    PropTypes.shape({id: PropTypes.number, type: PropTypes.string})
  ),
  /**
   * Function to invoke when SetAsNextSlide step button is clicked
   */
  setAsNextStep: PropTypes.func,
  /**
   * Operation description message to be displayed on top of
   * options list.
   */
  optionsDescription: PropTypes.string,
  /**
   * Type is used to check the type of current design slide
   */
  type: PropTypes.oneOf([
    'DESIGN_SLIDE_TWO',
    'DESIGN_SLIDE_THREE',
    'DESIGN_SLIDE_ONE',
  ]),
};

OptionsBlock.defaultProps = {
  optionsDescription: '',
  optionsList: [],
  optionsTitle: '',
};
